import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import Button from '@mui/material/Button';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import { useRecordContext } from 'react-admin';

import { impersonate } from '@src/services/api/impersonate';

const ImpersonateButton = (props) => {
    const recordContext = useRecordContext();
    const record = props.record || recordContext;

    const handleClick = useCallback((e) => {
        e.preventDefault();
        if (!record || !record.id) return;

        impersonate(record.id).then((data) => {
            const a = document.createElement('a');
            a.href = `${process.env.FRONTEND_HOST}?admin_jwt=${data.admin_jwt}&agent_jwt=${data.agent_jwt}`;
            a.setAttribute('target', '_blank');
            a.click();
        }).catch((error) => {
            console.error(error);
        });
    }, [record]);

    if (!record) {
        return null;
    }

    if (record.banned) {
        return 'Banned';
    }

    return (
        <Button
            color="primary"
            startIcon={<AssignmentIndIcon />}
            endIcon={<OpenInNewIcon />}
            rel="noopener noreferrer"
            target="_blank"
            size="small"
            onClick={handleClick}
        >
            Masquerade
        </Button>
    );
};

ImpersonateButton.propTypes = {
    record: PropTypes.object,
};

export default ImpersonateButton;
